import { render, staticRenderFns } from "./models.vue?vue&type=template&id=7a5a7238&scoped=true&"
import script from "./models.vue?vue&type=script&lang=js&"
export * from "./models.vue?vue&type=script&lang=js&"
import style0 from "./models.vue?vue&type=style&index=0&id=7a5a7238&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5a7238",
  null
  
)

export default component.exports